/* eslint-disable max-len */
/**
 * Polish translations.
 */
export default {
  ACTION: {
    CANCEL: 'Anuluj',
    CONFIRM: 'Potwierdzenie',
    NEW_INVOICE: 'Nowa faktura'
  },
  ERROR: {
    ACCUMULATE_SUBMITTED: 'Błąd przesyłania akumulacji',
    CANCEL_ACCUMULATION:
      'Błąd podczas anulowania rozliczeń międzyokresowych biernych',
    CANCEL_INVOICE: 'Błąd podczas anulowania faktury',
    COUPON_CANCELED: 'Błąd podczas anulowania kuponu',
    COUPON_GENERATED: 'Błąd generowania kuponu',
    ERROR: 'Błąd',
    INVOICE_SUBMITTED: 'Błąd podczas przesyłania faktury'
  },
  HEADER: {
    ACCU_REMUNERATION: 'Wynagrodzenie Acu.',
    ATTACHMENT: 'Załącznik',
    CHALLENGE: 'Wyzwanie',
    COUPON: 'Kupon',
    COUPON_CODE: 'Kod kuponu',
    DECISION: 'Decyzja',
    MONTH: 'Miesiąc',
    OBSERVATIONS: 'Obserwacje',
    REMUNERATION: 'Wynagrodzenie',
    STATE: 'Stan',
    SUBMISSION_DATE: 'Data przesłania'
  },
  LABEL: {
    ACCUMULATE: 'Kumulacja',
    ACCUMULATED: 'Łącznie',
    ACTIVES: 'Aktywny',
    ALL: 'Wszystkie',
    BEGIN_DATE: 'Data rozpoczęcia',
    CANCEL: 'Anuluj',
    CANCEL_ACCUMULATION: 'Anulowanie akumulacji',
    CANCEL_COUPON: 'Anuluj kupon',
    CANCEL_INVOICE: 'Anuluj fakturę',
    CLOSE: 'Zamknij',
    CODE: 'Kod',
    CONFIRM: 'Potwierdzenie',
    CONFIRM_ACCUMULATE: 'Kumulacja',
    CONFIRM_COUPON_CREATION: 'Generowanie kuponu',
    CONFIRM_SUBMIT_INVOICE: 'Wyślij',
    COPY_COUPON_CODE: 'Kopiuj kod',
    COUPON: 'Kupon',
    COUPON_CODE: 'Kod kuponu',
    CURRENT_PERIOD: 'P. corr.',
    DATE: 'Data',
    DESCRIPTION: 'Opis',
    END_DATE: 'Data zakończenia',
    FILTER: 'Filtr',
    GENERATE_COUPON: 'Generowanie kuponu',
    GO_TO_DETAILS: 'Zobacz produkty',
    INVOICE: 'Faktura',
    MODEL: 'Model',
    MONEY: 'Pieniądze',
    MONTH: 'Miesiąc',
    NEW_INVOICE: 'Nowa faktura',
    PAYMENT_METHOD: 'Metoda płatności',
    PENDING_COUNTERPARTS: 'Oczekujące odpowiedniki',
    PENDING_COUNTERPARTS_MODAL_TITLE:
      'Istnieją odpowiedniki, które nie zostały jeszcze zweryfikowane',
    PENDING_VALUE: 'Kwota do zafakturowania',
    PREVIOUS_PERIOD: 'P. ant.',
    REMUNERATION: 'Wynagrodzenie',
    SELECTED_PRODUCTS: 'Wybrane produkty',
    STATE: 'Stan',
    SUBMIT_INVOICE_ATTACHMENT: 'Załączniki (PDF)',
    SUBMIT_INVOICE_COMMENT: 'Komentarz',
    SUBMIT_MANUAL_REMUNERATION_INVOICE_VALUE: 'Wartość',
    WITHOUT_PRODUCTS: 'Brak wybranych produktów',
    YEAR: 'Rok'
  },
  SENTENCE: {
    CANCEL_ACCUMULATION: 'Czy na pewno chcesz anulować akumulację?',
    CANCEL_COUPON: 'Czy na pewno chcesz anulować kupon {value}?',
    CANCEL_INVOICE: 'Czy na pewno chcesz anulować przesyłanie faktur?',
    CANT_GENERATE_COUPON: 'Nie może generować kuponów.',
    CANT_SUBMIT_REMUNERATION: 'Nie można przesłać faktury.',
    CONFIRM_SUBMIT_COUPON:
      'Generujesz kupon dla {couponValue}. Czy chcesz zakończyć tę operację?',
    EMPTY_TITLE: 'Brak wyników'
  },
  SUCCESS: {
    ACCUMULATE_SUBMITTED: 'Skumulowane wynagrodzenie',
    CANCEL_ACCUMULATION: 'Anulowane rozliczenia międzyokresowe bierne',
    CANCEL_INVOICE: 'Faktura anulowana',
    COUPON_CANCELED: 'Kupon anulowany',
    COUPON_COPIED: 'Skopiowany kod kuponu',
    COUPON_GENERATED: 'Kupon wygenerowany z kodem %{value}',
    INVOICE_SUBMITTED: 'Złożona faktura',
    SUCCESS: 'Sukces'
  },
  TOOLTIP: {
    ACCU_REMUNERATION: 'Wynagrodzenie Acu.',
    ATTACHMENT: 'Załącznik',
    CHALLENGE: 'Wyzwanie',
    COUPON: 'Kupon',
    COUPON_CODE: 'Kod kuponu',
    DECISION: 'Decyzja',
    MONTH: 'Miesiąc',
    OBSERVATIONS: 'Obserwacje',
    REMUNERATION: 'Wynagrodzenie',
    STATE: 'Stan',
    SUBMISSION_DATE: 'Data przesłania',
    SWIPE: 'Przesuń w lewo, aby zobaczyć więcej kolumn.',
    VIEW_CHALLENGE_DETAILS: 'Zobacz szczegóły wyzwania'
  }
};
